export default __webpack_public_path__ + "static/jimmy-video-0819a19b1488e485765d2797ac7deb08.mp4";